export default "__VITE_ASSET__2KNAu6pD__"